import { createFileRoute } from '@tanstack/react-router';
import SpecialDates from 'src/pages/Organization/SpecialDates';

export const Route = createFileRoute(
  '/$organizationSlug/settings/special_dates/',
)({
  component: SpecialDates,
});
